((blogLanding, $) => {
  "use strict";
  const $dom = {};
  let page = 1;
  let allArticleList = [];
  let searchedArticleList = [];

  const cacheDom = () => {
    $dom.tagSelect = $('[js-blog="tag"]');
    $dom.searchInput = $('[js-blog="search"]');
    $dom.searchForm = $('[js-blog="search-form"]');
    $dom.paginationPrev = $('[js-blog-pagination="prev"]');
    $dom.paginationNext = $('[js-blog-pagination="next"]');
    $dom.paginationLabel = $('[js-blog-pagination="label"]');
    $dom.footer = $('[js-blog="footer"]');
    $dom.viewAll = $('[js-blog="view-all"]');
    $dom.blogContent = $('[js-blog="content"]');
    $dom.blogList = $('[js-blog="list"]');
  };

  const bindUIActions = () => {
    $dom.viewAll.on('click', event => {
      event.preventDefault();
      viewAllBlogs();
    });

    $dom.tagSelect.on('change', event => {
      event.preventDefault();
      setPagination(1);
      updateUrlParams();
      fetchArticles();
    });

    $dom.searchInput.on('keyup', event => {
      if (event.key === 'Enter' || event.keyCode === 13) {
        setPagination(1);
        updateUrlParams();
        doSearch();
      }
    });

    $dom.paginationPrev.on('click', event => {
      page = page - 1;
      updateUrlParams();
      displayArticles();
    });

    $dom.paginationNext.on('click', event => {
      page = page + 1;
      updateUrlParams();
      displayArticles();
    });

    $dom.searchForm.on('submit', event => {
      event.preventDefault();
      setPagination(1);
      updateUrlParams();
      doSearch();
    });
  }

  const doSearch = () => {
    const search = $dom.searchInput.val();
    searchedArticleList = allArticleList.filter(article => article.title.toLowerCase().includes(search.toLowerCase()));
    displayArticles();
  }

  const fetchArticles = (search = false, pageNumber = 1) => {
    const selTag = $dom.tagSelect.val().replace(/\s/g, '-');
    const blogHandle = $dom.blogContent.data('blog-handle');
    let url = `/blogs/${blogHandle}`;
    if(selTag !== 'All') {
      url += `/tagged/${selTag}`;
    }

    url += '?view=json';

    $.get(url, function(data) {
      allArticleList = JSON.parse(data);
      searchedArticleList = JSON.parse(data);
      setPagination(pageNumber);
      updateUrlParams();
      if (search) {
        doSearch();
      } else {
        $dom.searchInput.val('');
        displayArticles();
      }
    });
  }

  const setPagination = (newPage = 1) => {
    page = newPage;
    $dom.footer.removeClass('is-active');

    if (page !== 1) {
      return;
    }

    $dom.paginationPrev.attr('disabled', 'disabled');
  }

  const displayArticles = () => {
    let maxArticlesPerPage = 6;
    let pageStartIndex = (page - 1) * maxArticlesPerPage;

    let featureArticle = searchedArticleList.find(article => article.is_feature);

    if(page == 1) {
      $dom.paginationPrev.attr('disabled', 'disabled');

      if(featureArticle) {
        maxArticlesPerPage = 5;
      }
    } else {
      $dom.paginationPrev.removeAttr('disabled');
      if(featureArticle) {
        pageStartIndex -= 1;
      }
    }

    $dom.blogList.empty();

    const currentPageArticles = searchedArticleList.slice(pageStartIndex, pageStartIndex + maxArticlesPerPage);

    if(searchedArticleList.length > pageStartIndex + currentPageArticles.length) {
      $dom.paginationNext.removeAttr('disabled');
    } else {
      $dom.paginationNext.attr('disabled', 'disabled');
    }

    $dom.footer.removeClass('is-active');
    let totPage = 1;
    let articleListHTML = [];
    if(featureArticle) {
      totPage = Number.parseInt(((searchedArticleList.length - 5) / 6)) + 2;
    } else {
      totPage = Number.parseInt((searchedArticleList.length/ 6)) + 1;
    }

    if(totPage >= 2) {
      $dom.footer.addClass('is-active');
      $dom.paginationLabel.text(`Page ${page} of ${totPage}`);
    }

    currentPageArticles.forEach(article => {
      const html = buildArticleCard(article, article.is_feature);
      articleListHTML.push(html);
    });
    $dom.blogList.append(articleListHTML.join(''));
    $dom.blogList.show();
  }

  const viewAllBlogs = () => {
    $dom.blogList.empty();

    let articleListHTML = [];

    searchedArticleList.forEach(article => {
      const html = buildArticleCard(article);
      articleListHTML.push(html);
    });
    $dom.blogList.append(articleListHTML.join(''));
    $dom.footer.removeClass('is-active');
  }

  const buildArticleCard = (article, isFeature = false) => {
    return `<a href="${article.url}" class="blog-content__card  ${isFeature && 'blog-content__card--featured' }">
              <div class="blog-content__card-image__wrapper">
                <img class="blog-content__card-image" src="${article.thumb}" alt="${article.title}">
              </div>
              ${isFeature ? '<span class="blog-content__card-badge">featured post</span>' : '' }
              <div class="blog-content__card-content">
                <p class="blog-content__card-tag">${article.tag}</p>
                <h2 class="blog-content__card-title">${article.title}</h2>
                <p class="blog-content__card-date">${article.published_at}</p>
              </div>
            </a>`;
  }

  const updateUrlParams = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const currentTag = $dom.tagSelect.val();
    const currentSearch = $dom.searchInput.val();

    if (currentTag) {
      urlParams.set(`tag`, currentTag);
    } else {
      urlParams.delete(`tag`);
    }

    if (currentSearch) {
      urlParams.set(`search`, currentSearch);
    } else {
      urlParams.delete(`search`);
    }

    urlParams.set(`page`, page);

    const newUrl = `${window.location.origin}${window.location.pathname}?${urlParams.toString()}${window.location.hash}`;
    window.history.pushState(null, newUrl, newUrl);
  };

  const initArticles = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const initialTag = urlParams.get(`tag`);
    const initialSearch = urlParams.get(`search`);
    const initialPage = urlParams.get(`page`) && Number.parseInt(urlParams.get(`page`));

    if (initialTag && $dom.tagSelect.find(`option[value="${initialTag}"]`).length > 0) {
      $dom.tagSelect.val(initialTag);
    }
    if (initialSearch) {
      $dom.searchInput.val(initialSearch);
    }

    fetchArticles(initialSearch, initialPage && !Number.isNaN(initialPage) ? initialPage : 1);
  };

  const init = () => {
    cacheDom();
    bindUIActions();
    initArticles();
  };

  blogLanding.init = init

})((window.blogLanding = window.blogLanding || {}), jQuery);